<template>
  <div class="map_box">
    <div class="map_img" ref="map">
      <img :src="mapImage" alt="" />
      <div
        class="pos_container"
        :style="{ width: w + 'px', height: h, left: 0 }"
      >
        <div
          v-for="(item, i) in listPos"
          :key="i"
          class="point"
          :style="item.pos"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import mapImage from "@/assets/images/map.png";
export default {
  data() {
    return {
      mapImage,
      listPos: [],
      h: "auto",
      w: "auto",
    };
  },
  mounted() {
    console.log(this.$imgLoading);
    this.init();
  },
  methods: {
    init() {
      if (window.ResizeObserver) {
        let resizeObserver = new window.ResizeObserver(() => {
          let { listPos } = this;
          this.$imgLoading(this.mapImage).then(({ per }) => {
            if (listPos.length == 0) return;
            if (this.$refs.map) {
              let list = [...listPos];
              let mpaboxWidth = this.$refs.map.offsetWidth; //* 0.3333;
              this.h = mpaboxWidth / per + "px";
              this.w = mpaboxWidth;
              let height = mpaboxWidth / per;
              let width = mpaboxWidth;
              list.forEach((item) => {
                let { x, y } = this.$convertLatLonToPixel(
                  item.longitude,
                  item.latitude,
                  width,
                  height
                );
                item.pos = { left: x - 12.5 + "px", top: y - 26 + "px" };
              });

              this.listPos = list;
            }
          });
        });
        resizeObserver.observe(this.$refs.map);
      }
    },
    setLatLon(list) {
      if (list && Array.isArray(list) && list.length) {
        this.$imgLoading(this.mapImage).then(({ per }) => {
          let mpaboxWidth = this.$refs.map.offsetWidth; //* 0.3333;
          // let mpaboxWidth = map.value.offsetWidth;
          let h = mpaboxWidth / per;
          let w = mpaboxWidth;
          list.forEach((item) => {
            let { x, y } = this.$convertLatLonToPixel(
              item.longitude,
              item.latitude,
              w,
              h
            );
            item.pos = { left: x - 12.5 + "px", top: y - 26 + "px" };
          });

          this.listPos = list;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.map_box {
  width: 100%;
  .map_img {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      object-fit: cover;
    }
    .pos_container {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      .point {
        position: absolute;
        width: 25px;
        height: 30px;
        background: url("../../assets/images/show_icon.png") no-repeat center
          center;
        background-size: 100% 100%;
        opacity: 1;
        cursor: pointer;
        &:hover {
          background: url("../../assets/images/active_show.png") no-repeat
            center center;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
